var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBogoAward = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 11 11"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.77,
  d: "m7.094 5.91.694 3.907a.23.23 0 0 1-.371.215L5.776 8.801a.46.46 0 0 0-.549 0l-1.643 1.23a.23.23 0 0 1-.372-.214l.694-3.908M8.25 3.668a2.75 2.75 0 1 1-5.5 0 2.75 2.75 0 0 1 5.5 0"
})));
export default SvgBogoAward;